'use client';

import React from 'react';

import Downloads from './downloads';
import { SelectedProductSlugsProvider } from './SelectedProductSlugsProvider';

interface DownloadsWrapperProps {
  products: Product[];
  downloadList: Record<string, DownloadListItem>;
  initialSlug?: string;
}

const DownloadsWrapper: React.FC<DownloadsWrapperProps> = ({ products, downloadList, initialSlug }) => {
  return (
    <SelectedProductSlugsProvider>
      <Downloads products={products} downloadList={downloadList} initialSlug={initialSlug} />
    </SelectedProductSlugsProvider>
  );
};

export default DownloadsWrapper;
